<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <b-carousel
                v-model="item"
                :autoplay="false"
                with-carousel-list
                :indicator="false"
                :overlay="gallery"
                @click="switchGallery(true)">
                <b-carousel-item v-for="(item, i) in selected.imagens" :key="i">
                    <figure class="image">
                        <img :src="item.image">
                    </figure>
                </b-carousel-item>
                <span v-if="gallery" @click="switchGallery(false)" class="modal-close is-large"/>
                <template #list="props">
                    <b-carousel-list
                        v-model="props.active"
                        :data="selected.imagens"
                        v-bind="al"
                        @switch="props.switch($event, false)"
                        as-indicator />
                </template>
            </b-carousel>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        selected: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            gallery: false,
            item: 0,
            al: {
                hasGrayscale: true,
                itemsToShow: 2,
                breakpoints: {
                    768: {
                        hasGrayscale: false,
                        itemsToShow: 4
                    },
                    960: {
                        hasGrayscale: true,
                        itemsToShow: 6
                    }
                }
            },
        }
    },
    created(){
        this.item = this.selected.index;
    },
    methods: {
        switchGallery(value) {
            this.gallery = value
            if (value) {
                document.documentElement.classList.add('is-clipped')
            } else {
                document.documentElement.classList.remove('is-clipped')
            }
        }
    }
}
</script>